export default {
      id: "slider_right_btn-usage",
      viewBox: "0 0 68 64",
      url: "/" + "images/icons.3.109.2.svg#slider_right_btn-usage",
      toString: function () {
        return this.url;
      }
    }